import { apiRequestActions } from '@ackee/redux-utils';

import { fetchIotConfigTypes } from './types';

export default apiRequestActions(fetchIotConfigTypes);
